import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as appRoute } from '../../_app'
import { useRequireAdmin } from '../../../lib/me-context'
import { AdminShell } from '../../../components/admin/AdminShell'
import { AdminSessionTable } from '../../../components/admin/AdminSessionTable'

/**
 * Admin open-sessions view (`/admin/sessions`) — every live session across the
 * platform and who opened it (read-only oversight). Auto-refreshes so the list
 * stays live. Guarded by {@link useRequireAdmin}.
 */
export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/admin/sessions',
  component: AdminSessionsPage,
})

function AdminSessionsPage() {
  const { t } = useTranslation('admin')
  const isAdmin = useRequireAdmin()

  if (!isAdmin) {
    return null
  }

  return (
    <AdminShell active="sessions" title={t('sessionsTitle')}>
      <AdminSessionTable />
    </AdminShell>
  )
}
